import React from 'react'
import Link from 'next/link';

function WriteForUs() {
  return (
    <div className="flex flex-col border-t border-gray-100 mt-8">
        <h3 className="!text-maturity-500 font-semibold leading-tight">Join Our Writing Team:<br />Contribute to Our Blog</h3>
        <p className="text-left">Are you passionate about writing and eager to share your insights and expertise with a wide audience? Then we&apos;d love to hear from you! Our blog covers a variety of topics and we&apos;re always on the lookout for fresh perspectives and new voices. Whether you&apos;re a seasoned blogger or just starting out, we welcome contributions from writers of all levels. If you&apos;re interested in being a part of a dynamic and growing community, <Link href="mailto:webmaster@arkarobot.com"><a className="text-trust underline">submit your proposal today!</a></Link></p>
    </div>
  )
}

export default WriteForUs